import { gql } from "@apollo/client";

export const QUERY_FOR_DASHBOARD = gql`
  query {
    merchantTotalHoldBalance {
      totalBalance
      holdBalance
      availableBalance
      feeBalance
      disbursementBalance
      lastUpdated
      disbursementPaid
      disbursementProcess
      onOrdering
    }

    merchantInventorySummary {
      totalUnit
      totalItem
      totalVolume
      fee
    }

    merchantSaleSummary {
      title
      completed
      return
      amountReturn
      sold
      sale
      total
    }
  }
`;
